import type { PropsWithChildren } from "react";
import { getSupportedChartAggregationTypes, supportedChartAggregations } from "../../../utilities/aggregationHelper.ts";
import { SupportedAggregationsContextProvider } from "../../viewer/common/context/SupportedAggregationsContextProvider.tsx";

export default function ChartContainer({ children }: PropsWithChildren) {
  return (
    <SupportedAggregationsContextProvider
      aggregations={supportedChartAggregations}
      getSupportedAggregationTypes={getSupportedChartAggregationTypes}
    >
      {children}
    </SupportedAggregationsContextProvider>
  );
}
